module.exports = __webpack_public_path__ + "img/multiple-choice-card.a43cda16.svg";